import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useGetHsptlzFormCreatedFileInfo } from 'features/HsptlzForm/model';
import { formatNumber } from 'shared/lib';

export const useCreateFileInfo = () => {
  const { contentCode } = useParams();
  const { data: fileInfo } = useGetHsptlzFormCreatedFileInfo(contentCode);
  useEffect(() => {
    const deptNm = document.querySelector('[name="deptNm"]');
    if (deptNm) {
      deptNm.innerHTML = fileInfo.deptNm;
    }

    const medrNm = document.querySelector('[name="medrNm"]');
    if (medrNm) {
      medrNm.innerHTML = fileInfo.medrNm;
    }

    const hsptlzWardRoom = document.querySelector('[name="hsptlzWardRoom"]');
    if (hsptlzWardRoom) {
      hsptlzWardRoom.innerHTML = `${fileInfo.hsptlzWard}/${fileInfo.hsptlzRoom}`;
    }

    const advancedRoomFee = document.querySelector('[name="advancedRoomFee"]');
    if (advancedRoomFee) {
      advancedRoomFee.innerHTML = `${formatNumber(fileInfo.advancedRoomFee)}원`;
    }
  }, []);
};
